import React from 'react';
import MivaltaLanding from '../../features/Landing/MivaltaLanding';

function App() {
  return <MivaltaLanding />;
}

export default App;
